import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
  useRouter,
} from 'expo-router';
import useLegalAgreements from 'features/myVaro/hooks/legal/useLegalAgreements';
import { MyVaroContext } from 'features/myVaro/provider/MyVaroContextProvider';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FlatList, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import ErrorScreen from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

const AgreementsScreen = () => {
  const router = useRouter();
  const { agreementTypes } = useLocalSearchParams<{
    agreementTypes: string;
  }>();
  const { agreementsListDetails, errorModel, loading } =
    useLegalAgreements(agreementTypes);
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'agreements',
  });
  const { setSelectedAgreement } = useContext(MyVaroContext);

  const { bottom } = useSafeAreaInsets();

  return (
    <View style={[styles.container, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: translatedText('legalAndPrivacy.title'),
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={() => navigateBack()}
            />
          ),
        }}
      />
      {agreementsListDetails && agreementsListDetails.length > 0 ? (
        <FlatList
          data={agreementsListDetails}
          renderItem={({ item }) => (
            <ListItem
              key={item?.id}
              primaryCopy={item?.title}
              onPress={() => {
                setSelectedAgreement?.({
                  url: item?.resource?.pdfDocument?.url ?? ''!,
                  title: item?.title ?? '',
                });
                router.push('/myvaro/legal/[id]');
              }}
            />
          )}
          ItemSeparatorComponent={() => (
            <View style={styles.hairLineDivider}>
              <HairLineDivider />
            </View>
          )}
          keyExtractor={(item) => item?.id}
          removeClippedSubviews={false}
        />
      ) : null}
      <ScreenTransitionOverlay
        isLoading={loading && !agreementsListDetails}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={errorModel ? <ErrorScreen {...errorModel} /> : null}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
    backgroundColor: theme.color.background.primary,
  },
  hairLineDivider: {
    backgroundColor: theme.color.background.primary,
    paddingHorizontal: theme.spacing.m,
  },
});

export default AgreementsScreen;
